export const l2TokenHolderFields = `
balance
holder
token
`;
